import * as React from "react";
import PhoneInput, { Country } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { FormControl, FormHelperText } from "@mui/material";
import PhoneTextFieldAdapter from "./PhoneTextFieldAdapter";

export interface IInternationalPhoneInput {
  value: string;
  name: string;
  onChange: (ev: { target: { name: string; value: string } }) => void;
  error?: string | null;
}

export const InternationalPhoneInput: React.FC<IInternationalPhoneInput> = ({
  value,
  name,
  onChange,
  error,
}) => {
  return (
    <FormControl error={!!error} sx={{ width: "100%" }}>
      <PhoneInput
        defaultCountry={"GB" as Country}
        displayInitialValueAsLocalNumber
        international
        addInternationalOption={false}
        countryCallingCodeEditable={false}
        value={value || ""}
        onChange={(val) => {
          onChange({ target: { name, value: val || "" } });
        }}
        style={{ height: "100%" }}
        inputComponent={PhoneTextFieldAdapter}
      />
      <FormHelperText>{error}</FormHelperText>
    </FormControl>
  );
};
